
import * as constants from "../Constatnts";
import axios from "axios";

export function addCashRegister(cashRegister) {
  return async (dispatch, getState) => {
    try {
      const user = getState().user.user;
  
      const token = getState().user.uat;
      const response = await axios.post(
        constants.API_URL + "/user/stores/cashregisters",
        cashRegister,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

        if (response.data.code === "0") {
      
          return response.data.newCashRegister.key;
        
      }
      else{
        alert(response.data.message || "failed to add cashregister");
      }
   
    } catch (error) {
      console.error("Error adding cashregister:", error.response || error.message);
      throw error;
    }
  };
}

export function getCashRegisters(storeID) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/user/stores/${storeID}/cashregisters`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data.cashRegisters || [];
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function deleteCashRegister(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.delete(
        `${constants.API_URL}/user/stores/cashregisters/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if(response.data.code=="0"){
        return true;
      }
      else{
        return false;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}



export function updateCashRegister(cashRegister, key) {
  return async (dispatch, getState) => {
    try {
      const user = getState().user.user;
  
      const token = getState().user.uat;
      const response = await axios.put(
        constants.API_URL + `/user/stores/cashregisters/${key}`,
        cashRegister,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

        if (response.data.code === "0") {
      
          return response.data.updatedCashRegister;
        
      }
      else{
        alert(response.data.message || "failed to update cashregister");
         return null;
      }
   
    } catch (error) {
      console.error("Error updating cashregister:", error.response || error.message);
      throw error;
    }
  };
}


export function updateLastClosingBalance(key, lastClosingBalance) {
  return async (dispatch, getState) => {
    try {
      const cashRegister={
        LastClosingBalance:lastClosingBalance
      }
      const user = getState().user.user;
  
      const token = getState().user.uat;
      const response = await axios.put(
        constants.API_URL + `/user/stores/cashregisters/${key}`,
        cashRegister,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

        if (response.data.code === "0") {
      
          return true;
        
      }
      else{
        alert(response.data.message || "failed to update cashregister");
        return false;
      }
   
    } catch (error) {
      console.error("Error updating cashregister:", error.response || error.message);
      throw error;
    }
  };
}


export function getLastClosingBalance(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/setup/lastclosingbalance/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data.lastClosingBalance;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

